export enum ErrorResponseType {
  UserAlreadyExistsException = 'UserAlreadyExistsException',
  UserNotFoundException = 'UserNotFoundException',
  OAuthException = 'OAuthException',
  AlreadyExistsException = 'AlreadyExistsException',
  WrongCurrentPasswordException = 'WrongCurrentPasswordException'
}
